"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styledComponents_1 = require("../styledComponents");
const TooltipContent = ({ timestamp }) => {
    const now = new Date();
    const then = new Date(timestamp);
    const seconds = Math.floor((Number(now) - Number(then)) / 1000);
    const days = Math.floor(seconds / (24 * 60 * 60));
    const hours = Math.floor(seconds / (60 * 60)) % 24;
    const minutes = Math.floor(seconds / 60) % 60;
    const daysStr = days > 0 ? days.toString().padStart(2, '0') + 'd ' : '';
    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        hoursStr,
        " hours, ",
        minutesStr,
        " minutes ago"));
};
const Timestamp = ({ timestamp }) => {
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const dateFormated = `${day.toString().padStart(2, '0')}/${month
        .toString()
        .padStart(2, '0')}/${year} ${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}`;
    return (react_1.default.createElement(styledComponents_1.StyledCustomTooltip, { sx: { fontSize: '1em' }, title: react_1.default.createElement(TooltipContent, { timestamp: timestamp }) },
        react_1.default.createElement(styledComponents_1.Tag, { style: { fontSize: '1em', margin: 0 } }, dateFormated)));
};
exports.default = Timestamp;
